"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.captchaOnSuccess = captchaOnSuccess;
exports.captchaOnExpire = captchaOnExpire;
exports.captchaOnError = captchaOnError;
/**
 * Handles successful reCAPTCHA verification.
 * @param {string} token - The reCAPTCHA token.
 */
function captchaOnSuccess(token) {
    let errorEl = document.getElementById('g-recaptcha-error');
    if (errorEl) {
        errorEl.classList.add('d-none', 'visually-hidden');
    }
}
/**
 * Fires when the reCAPTCHA response expires and the user needs to re-verify.
 */
function captchaOnExpire() {
    let errorEl = document.getElementById('g-recaptcha-error');
    if (errorEl) {
        errorEl.innerHTML = `<small class="text-error">Your reCAPTCHA verification has expired. Please resubmit.</small>`;
        errorEl.classList.remove('d-none', 'visually-hidden');
    }
}
/**
 * Fires when reCAPTCHA encounters an error (e.g., network issues).
 */
function captchaOnError(message) {
    let errorEl = document.getElementById('g-recaptcha-error');
    if (errorEl) {
        if (!message) {
            message = `Unable to connect to Google's reCAPTCHA servers. Please check your connectivity!`;
        }
        errorEl.innerHTML = `<small class="text-error">${message}</small>`;
        errorEl.classList.remove('d-none', 'visually-hidden');
    }
}
